import React, { useEffect, useState } from 'react';
import '../../App.css';
import '../case-details/caseDetails.css';
import docIcon from '../../images/doc-ico.svg';
import stmIcon from '../../images/statem-ico.svg';
import flybIcon from '../../images/flyby-ico.svg';
import { IMG_URL } from "../../config.js";
import { useLocation } from "react-router-dom";

// Fallback icon if benefit icon is missing
import benefitIconFallback from '../../images/risk-shield-icon.svg';

function CaseDetails({ data, products }) {
  const isLoading = !data || Object.keys(data).length === 0;

  // Prepare benefit icons array, fallback to empty strings to avoid undefined errors
  const benefitIcons = data?.benefitIcons || [
    data?.strenthimage1 || '',
    data?.strenthimage2 || '',
    data?.strenthimage3 || '',
    data?.strenthimage4 || '',
  ];

  const location = useLocation();

  useEffect(() => {

    if (location.hash === "#eligibility") {

      setTimeout(() => {
        const el = document.getElementById("eligibility");

        if (el) {
          const yOffset = -150;
          const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;

          window.scrollTo({ top: y, behavior: "smooth" });
        }
      }, 200);

    }

  }, [location]);

  return (
    <section className="case-det-wrapp" id="case_update">
      <div className="container">
        {/* Allegations Heading */}
        {isLoading ? (
          <div className="skeleton skeleton-heading" />
        ) : (
          <h2 dangerouslySetInnerHTML={{ __html: data.heading1 }} />
        )}

        <div className="row casedet-row">
          {/* Allegations Content */}
          <div className="col-md-6 casedet-col1">
            {isLoading ? (
              <div className="skeleton skeleton-text-block" />
            ) : (
              <div
                className="casedet-cont"
                dangerouslySetInnerHTML={{ __html: data.subheading1 }}
              />
            )}
          </div>

          {/* Pricing Table */}
          <div className="col-md-6 casedet-col2">
            <div className="casedet-table">
              {isLoading ? (
                <div className="skeleton skeleton-table" />
              ) : (
                <table className="sting-table">
                  <thead>
                    <tr>
                      <th>Product Type</th>
                      <th>Regular Price</th>
                      <th>Price Spike</th>
                      <th>Discount Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    {products && products.length > 0 ? (
                      products.map((product) => (
                        <tr key={product.id}>
                          <td>{product.product_type}</td>
                          <td>{product.regular_price}</td>
                          <td>{product.price_spike}</td>
                          <td className="sting-price">{product.discount_price}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={4}>No product data available.</td>
                      </tr>
                    )}
                    <tr className="is-note">
                      <td colSpan={4}>
                        <em>
                          Illustrative examples only. Register to view the full list of affected products in your client portal.
                        </em>
                      </td>
                    </tr>
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>

        {/* Eligibility Section */}
        <div className="case-row2" id="eligibility">
          {isLoading ? (
            <>
              <div className="skeleton skeleton-subheading" />
              <div className="skeleton skeleton-text-block" />
            </>
          ) : (
            <>
              <span dangerouslySetInnerHTML={{ __html: data.heading2 }} />

              <div className="row">
                <div className="col-md-7">
                  <div className="case2-col1">
                    <div className="eligibility-checklist">
                      <h4>{data.subheading2}</h4>
                      <div className="checklist-item">
                        <h6 dangerouslySetInnerHTML={{ __html: data.description2 }} />
                      </div>
                      <div className="checklist-item">
                        <h6 dangerouslySetInnerHTML={{ __html: data.heading3 }} />
                      </div>
                      <div className="checklist-item">
                        <h6 dangerouslySetInnerHTML={{ __html: data.subheading3 }} />
                      </div>
                      <div className="checklist-item">
                        <h6 dangerouslySetInnerHTML={{ __html: data.description3 }} />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Document Card */}
                <div className="col-md-5">
                  <div className="document-card">
                    <h4>{data.mainheading}</h4>
                    <ul>
                      <li>
                        <span><img src={docIcon} alt="Document Icon" /></span> {data.smallcontent1}
                      </li>
                      <li>
                        <span><img src={stmIcon} alt="Statement Icon" /></span> {data.smallcontent2}
                      </li>
                      <li>
                        <span><img src={flybIcon} alt="Flyby Icon" /></span> {data.smallcontent3}
                      </li>
                    </ul>
                    <div dangerouslySetInnerHTML={{ __html: data.link1 }} />
                   <a href="/registerPage" className="doc-btn">
  Register Now
</a>

                  </div>
                </div>
              </div>
            </>
          )}
        </div>

        {/* Benefits Section */}
        <div className="case-row3">
          {isLoading ? (
            <div className="skeleton skeleton-large-block" />
          ) : (
            <>
              <h3>{data.link2}</h3>
              <div className="benefit-grid">
                {[data.link3, data.btnlink1, data.btnlink2, data.btnlink3].map((item, i) => (

                      // {[data.btnlink1, data.btnlink2, data.btnlink3, data.link3].map((item, i) => (


                  <div key={i} className="benefit-card">
                    <img
                      src={benefitIcons[i] ? `${IMG_URL}/public/${benefitIcons[i]}` : benefitIconFallback}
                      alt={`Benefit Icon ${i + 1}`}
                      className="benefit-card__icon"
                    />
                    <div dangerouslySetInnerHTML={{ __html: item }} />
                  </div>
                ))}
              </div>
            </>
          )}
        </div>

        {/* CTA Section */}
        <div className="case-cta">
          {isLoading ? (
            <>
              <div className="skeleton skeleton-text" />
              <div className="skeleton skeleton-btn" />
            </>
          ) : (
            <>
              <p>{data.join1}</p>
              <div className="cta-buttons">
                <a href="/registerpage" className="cta-btn1">{data.join2}</a>
                <a href="/loginPage" className="cta-btn2">{data.join3}</a>
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
}

export default CaseDetails;
